import { pickRandomElement } from "~utils";

import {
  BoardBackground,
  DarkModeUITheme,
  LightModeUITheme,
  Preferences,
  ThemeMode,
  TokenStyle,
} from "./preferences";

export function mockPreferences(overrides?: Partial<Preferences>): Preferences {
  return {
    theme: {
      [ThemeMode.Dark]: pickRandomElement(Object.values(DarkModeUITheme)),
      [ThemeMode.Light]: pickRandomElement(Object.values(LightModeUITheme)),
    },
    themeMode: pickRandomElement(themeModes),
    tokenStyle: pickRandomElement(Object.values(TokenStyle)),
    boardBackground: pickRandomElement(Object.values(BoardBackground)),
    ...overrides,
  };
}

const themeModes = Object.values(ThemeMode);
